import MainLayout from '../../components/Layouts/MainLayout/MainLayout';

const Terms = () => {

	return(
		<MainLayout>
			<div className='row pt-5'>
				<div className='col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2'>
					<h1>Terms of Use</h1>
					<p>Latest update: February 9, 2026</p>

		      <p>
		        These Terms of Use apply to your use of Political Predictions and <a href="politicalpredictions.com"> 
		        PoliticalPredictions.com</a> along with any associated software applications and websites (all together, 
		        	<strong>“Services”</strong>). These Terms form an agreement between you (<strong>“End User”</strong>) 
		        and FiscalNote, Inc., a Delaware corporation, (<strong>“Provider”</strong>, <strong>“Us”</strong>, 
		        	<strong>“We”</strong>, or <strong>“Our”</strong>), and they include important provisions for 
		        resolving disputes through arbitration. By using our Services, you agree to these Terms.
		      </p>				  

		      <h2>1. Access &amp; Services</h2>

				  <p>
				    <strong>1.1. Minimum Age Representation.</strong> By your use of the Services,
				    you represent that you are at least 18 years of age or the minimum age
				    required in your country.
				  </p>

				  <p>
				    <strong>1.2. License and Term.</strong> Provider grants End User a limited,
				    non-exclusive, non-transferable, non-sublicensable, worldwide right to
				    access the Services during the Subscription Term, subject to the terms of
				    this Agreement.
				  </p>

				  <p>
				    <strong>1.3. Restrictions.</strong> You agree not to act outside the scope of
				    the rights that are expressly granted by Provider in this Agreement,
				    including, but not limited to:
				  </p>

				  <ul>
				    <li>
				      (a) using the Services in any manner that is harmful, abusive, illegal, or
				      inconsistent with this Agreement;
				    </li>
				    <li>
				      (b) modifying any program code of the Services or attempting to create or
				      permit the creation of any derivative works of the Services;
				    </li>
				    <li>
				      (c) accessing or using the Services to develop or support, or assisting
				      another party in developing or supporting, any products or services
				      competitive with the Services;
				    </li>
				    <li>
				      (d) decompiling, reverse engineering, or otherwise attempting to view or
				      recreate any source code of the Services or extract any trade secrets;
				    </li>
				    <li>
				      (e) using the Services to operate the business of a third party or to
				      process data or content on a third party’s behalf;
				    </li>
				    <li>
				      (f) knowingly or intentionally using, disseminating, or copying the
				      Services or associated Content in a way that infringes or violates any
				      intellectual property or other rights of Provider or any third party;
				    </li>
				    <li>
				      (g) publicly disclosing or otherwise making available any Provider Content
				      or Output without citing Provider or CQ Roll Call as the source; or
				    </li>
				    <li>
				      (h) selling, lending, leasing, assigning, transferring, pledging, or
				      sublicensing any rights granted under this Agreement.
				    </li>
				  </ul>

				  <p>
				    <strong>1.4. No Interference with Service Operations.</strong> End Users will
				    not take any action to (a) interfere with the proper working of the Services
				    or (b) circumvent, disable, or interfere with Provider’s security-related
				    features or usage limitations.
				  </p>

				  <p>
				    <strong>1.5. Suspension of Services.</strong> Provider may limit or suspend the
				    Services to perform maintenance, stop violations of this Agreement, prevent
				    material harm, address excessive infrastructure load, maintain service
				    operations, or comply with Applicable Law.
				  </p>

				  <p>
				    <strong>1.6. Third-Party Services.</strong> If you integrate the Services with
				    any non-Provider third-party services, you acknowledge that such services
				    may access or use End User Data as required for interoperability. You are
				    solely responsible for the use of such third-party services and any resulting
				    data loss or damages.
				  </p>

				  <p>
				    <strong>1.7. End User Content.</strong> If the Services allow End Users to
				    upload, store, manage, or use content, Provider may remove or disable access
				    to any End User Content that is unlawful, misleading, defamatory, abusive,
				    obscene, offensive, or otherwise objectionable. Provider has no obligation
				    to monitor or pre-screen End User Content and is not responsible for delays
				    or failures in removal.
				  </p>

				  <h2>2. Warranties &amp; Disclaimers</h2>

				  <p>
				    <strong>2.1. Warranties.</strong> Each party represents and warrants that
				    (a) it has full power and authority to enter into this Agreement,
				    (b) the execution and performance of its obligations under this Agreement
				    will not conflict with or violate any Applicable Law or any other agreement
				    to which the representing party is bound, and (c) it will comply with all
				    Applicable Law related to its provision or use of the Services.
				  </p>

				  <p>
				    <strong>2.2. Disclaimers.</strong>
				  </p>

				  <p>
				    <strong>2.2.1.</strong> PROVIDER MAKES NO REPRESENTATION OR WARRANTY ABOUT THE
				    SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED
				    TO, ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
				    DATA ACCURACY, SYSTEM INTEGRATION, NON-INFRINGEMENT, NON-INTERFERENCE, AND/OR
				    QUIET ENJOYMENT.
				  </p>

				  <p>
				    <strong>2.2.2.</strong> PROVIDER DOES NOT WARRANT THAT OPERATION OF THE
				    SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, OR THAT ALL ERRORS WILL BE
				    CORRECTED.
				  </p>

				  <p>
				    <strong>2.2.3.</strong> PROVIDER IS NOT PROVIDING LEGAL OR OTHER PROFESSIONAL
				    ADVICE. END USER’S DECISIONS MADE IN RELIANCE ON THE SERVICES OR CUSTOMER’S
				    INTERPRETATION OF ANY CONTENT ARE END USER’S OWN RESPONSIBILITY AND ARE
				    ASSUMED AT END USER’S OWN RISK.
				  </p>

				  <p>
				    <strong>2.2.4.</strong> PROVIDER IS NOT RESPONSIBLE FOR THIRD-PARTY PROVIDED
				    PRODUCTS, CONTENT, OR SERVICES. PROVIDER CONTENT IS AGGREGATED FROM
				    UNAFFILIATED THIRD-PARTY SOURCES AND PROVIDER IS NOT RESPONSIBLE FOR SUCH
				    CONTENT.
				  </p>

				  <p>
				    <strong>2.2.5.</strong> THE SERVICES ARE PROVIDED “AS IS” AND WITHOUT WARRANTY
				    OF ANY KIND.
				  </p>

				  <h2>3. Indemnities</h2>

				  <p>
				    <strong>3.1. Indemnification Obligation.</strong> If End User accesses the
				    Services for, on behalf of, or as an agent of a business or organization, to
				    the extent permitted by law, such business or organization will indemnify
				    and hold harmless Provider, its affiliates, and its personnel from and
				    against any costs, losses, liabilities, and expenses (including attorneys’
				    fees) arising out of or relating to End User’s use of the Services or any
				    violation of these Terms.
				  </p>

				  <p>
				    <strong>3.2. Indemnity Procedures.</strong> If Provider seeks indemnification,
				    it will promptly notify the other party of the claim and reasonably
				    cooperate in the defense. The indemnifying party will control the defense,
				    except that (a) any settlement requiring Provider to admit liability,
				    perform any act, or pay any money requires Provider’s prior written consent
				    (not unreasonably withheld or delayed), and (b) Provider may participate in
				    the defense with its own counsel at its own expense.
				  </p>

				  <h2>4. Liability</h2>

				  <p>
				    <strong>4.1. Consequential Damages Waiver.</strong> NEITHER PARTY WILL BE
				    LIABLE UNDER OR IN CONNECTION WITH THIS AGREEMENT FOR (A) ANY INDIRECT,
				    CONSEQUENTIAL, SPECIAL, INCIDENTAL, PUNITIVE, OR EXEMPLARY DAMAGES OR (B)
				    LOSS OF OR DAMAGE TO DATA, BUSINESS, REVENUES, OR PROFITS, WHETHER DIRECT OR
				    INDIRECT, EVEN IF SUCH DAMAGES WERE FORESEEABLE OR A REMEDY FAILS OF ITS
				    ESSENTIAL PURPOSE.
				  </p>

				  <p>
				    <strong>4.2. Liability Cap.</strong> PROVIDER’S LIABILITY WILL NOT EXCEED THE
				    GREATER OF THE AMOUNT PAID BY END USER FOR THE SERVICE GIVING RISE TO THE
				    CLAIM IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM OR ONE HUNDRED DOLLARS
				    ($100).
				  </p>

				  <p>
				    <strong>4.3. Third-Party Beneficiaries.</strong> PROVIDER’S AFFILIATES,
				    SUPPLIERS, LICENSORS, AND DISTRIBUTORS ARE INTENDED THIRD-PARTY BENEFICIARIES
				    OF THIS SECTION.
				  </p>

				  <h2>5. End User Obligations</h2>

				  <p>
				    <strong>5.1. End User Activities.</strong> You are responsible for complying
				    with this Agreement. If you are acting as an agent of a company or
				    organization, such company or organization shall be responsible for your
				    acts and activities.
				  </p>

				  <p>
				    <strong>5.2. Embargoes.</strong> You represent and warrant that neither you
				    nor your company or organization (if applicable) is barred by any
				    Applicable Law from being supplied with the Services. The Services may not
				    be used in any country subject to an embargo by the United States or the
				    European Union (EU), as applicable. End User will ensure that:
				  </p>

				  <ul>
				    <li>
				      (a) it does not use the Services in violation of any export restriction or
				      embargo imposed by the United States;
				    </li>
				    <li>
				      (b) it does not use the Services in any manner that would violate
				      sanctions administered or enforced by the Office of Foreign Assets
				      Control, the U.S. Department of State, the United Nations Security Council,
				      the European Union or any EU member state authority, His Majesty’s
				      Treasury, or any other relevant sanctions authority; and
				    </li>
				    <li>
				      (c) it does not provide access to the Services to persons listed on the
				      U.S. Department of Commerce’s Denied Persons List or Entity List or the
				      U.S. Treasury Department’s list of Specially Designated Nationals.
				    </li>
				  </ul>

				  <h2>6. Artificial Intelligence</h2>

				  <p>
				    <strong>6.1. AI Features.</strong> The Services utilize generative artificial
				    intelligence, machine learning, or similar technologies (the “AI
				    Features”). If End User uses Provider’s generative AI assistant or copilot
				    (the “Assistant”), End User may submit information, including End User
				    Data, prompts, text, or other input (collectively, “Input”) and receive
				    output generated by the Assistant (“Output,” and together with Input, the
				    “AI Content”).
				  </p>

				  <p>
				    Such Output is generated based on Provider’s proprietary training
				    materials, prompt engineering, and insights and may not be unique across
				    users. Subject to Section 9, Provider grants End User a non-exclusive,
				    worldwide license to use, display, and create derivative works of the
				    Output during the Subscription Term.
				  </p>

				  <p>
				    Provider may use End User usage patterns to develop or improve personalized
				    features unique to End Users, or may aggregate and anonymize End User
				    Inputs to identify trends or improve the Services.
				  </p>

				  <p>
				    Certain AI Features are powered by third-party AI model providers,
				    including OpenAI, LLC (“Third Party Services”), and some portions of the
				    Services may include output generated by those services (“Third Party
				    Output”). Third Party Services and Third Party Output are governed by their
				    own terms, and Provider is not responsible for them.
				  </p>

				  <p>
				    <strong>6.2. Use of AI Features.</strong> End User is solely responsible for
				    all Input and for ensuring that use of AI Content complies with Applicable
				    Law and this Agreement. End User acknowledges that AI Content may contain
				    inaccuracies and should not be relied upon without independent
				    verification and appropriate human review.
				  </p>

				  <p>
				    Provider does not guarantee the accuracy, completeness, or appropriateness
				    of AI Content. Output may be incomplete, incorrect, or offensive and does
				    not represent Provider’s views. References to third-party products or
				    services do not imply endorsement or affiliation.
				  </p>

				  <p>
				    <strong>6.3. EU AI Provisions.</strong> If End Users are located within the
				    European Union, the following provisions apply.
				  </p>

				  <p>
				    <strong>6.3.1. EU AI Restrictions.</strong> End User will not, without
				    Provider’s prior written consent:
				  </p>

				  <ul>
				    <li>
				      (a) use AI Features, Content, or Output in violation of Applicable Law,
				      regulations, or guidelines, including the Artificial Intelligence Act
				      (Regulation (EU) 2024/1689) (“EU AI Act”); or
				    </li>
				    <li>
				      (b) sublicense, sell, lease, or otherwise distribute AI Features,
				      Content, or Output to any third party.
				    </li>
				  </ul>

				  <p>
				    <strong>Transparency, Accountability, Governance &amp; Oversight.</strong>
				    Provider shall ensure that AI Features are designed, developed, and
				    deployed in a transparent, traceable, and auditable manner; that clear and
				    understandable information regarding AI capabilities, limitations, and
				    risks is provided; that appropriate data governance and risk assessment
				    measures are implemented; and that AI Features support effective human
				    oversight, including the ability to monitor, interpret, override, or stop
				    the system when necessary.
				  </p>

				  <h2>7. Term and Termination</h2>

				  <p>
				    <strong>7.1. Term of Agreement.</strong> This Agreement commences on the date
				    you first use the Services and continues until terminated. You may stop
				    using the Services at any time, at which point this Agreement will
				    terminate, subject to Section 7.2.
				  </p>

				  <p>
				    <strong>7.2. Survival.</strong> Section 1.3 (Restrictions), Section 3
				    (Indemnities), Section 4 (Liability), Section 8 (Data Privacy), Section 9
				    (Intellectual Property), Section 10 (Confidentiality), Section 13
				    (Miscellaneous), and any provisions that by their nature should survive
				    termination or expiration shall survive.
				  </p>

				  <h2>8. Data Privacy</h2>

				  <p>
				    <strong>8.1. Data Protection &amp; Security.</strong> The following Data
				    Processing Agreements (“DPAs”) apply where Provider processes Personal Data
				    for or on behalf of End Users:
				  </p>

				  <p>
				    <strong>8.1.1. For U.S. Residents.</strong> When Provider provides Services
				    involving the processing of U.S. residents’ Personal Data, the Data
				    Protection Agreement (U.S.) applies and forms part of this Agreement.
				  </p>

				  <p>
				    <strong>8.1.2. For EU / UK Residents.</strong> When Provider provides Services
				    involving the processing of European Union (“EU”) and/or United Kingdom
				    (“UK”) residents’ Personal Data, the Data Protection Agreement (EU &amp; UK)
				    applies and forms part of this Agreement.
				  </p>

				  <p>
				    <strong>8.2. DPAs Incorporated into Agreement.</strong> The DPAs referenced in
				    these Terms are incorporated by reference and form part of this Agreement.
				    In the event of a conflict between the applicable DPA and these Terms, the
				    terms of the applicable DPA shall control.
				  </p>

				  <h2>9. Intellectual Property</h2>

				  <p>
				    Provider retains ownership of and all Intellectual Property Rights in the
				    Services, Provider Content, AI Features, Output, and any other products,
				    services, or materials provided by or on behalf of Provider. No licenses or
				    rights are granted to End User except as expressly set forth in this
				    Agreement.
				  </p>

				  <h2>10. Confidentiality</h2>

				  <p>
				    <strong>10.1. Definition.</strong> “Confidential Information” means
				    information disclosed by a party (“Discloser”) to the other party
				    (“Recipient”) in connection with the Services that is marked confidential
				    or would reasonably be considered confidential. Confidential Information
				    does not include information that:
				  </p>

				  <ul>
				    <li>(a) is or becomes public through no fault of the Recipient;</li>
				    <li>(b) was lawfully known by the Recipient prior to disclosure;</li>
				    <li>
				      (c) is rightfully received from a third party without restriction; or
				    </li>
				    <li>
				      (d) is independently developed without reference to the Discloser’s
				      Confidential Information.
				    </li>
				  </ul>

				  <p>
				    <strong>10.2. Confidentiality Obligations.</strong> The Recipient shall
				    (a) protect Confidential Information using commercially reasonable efforts;
				    (b) use Confidential Information solely as permitted under this Agreement;
				    and (c) not disclose Confidential Information without prior consent, except
				    to Affiliates, employees, agents, or professional advisors with a need to
				    know and confidentiality obligations. Disclosure may be made where required
				    by law, provided reasonable notice is given when permitted.
				  </p>

				  <p>
				    <strong>10.3. Exception for Customer Lists.</strong> If End User is a company
				    or organization, Provider may include End User’s name in its customer list
				    and generally describe the services provided.
				  </p>

				  <h2>11. Insurance</h2>

				  <p>
				    Each party shall maintain, at its own expense, appropriate liability
				    insurance or self-insurance sufficient to cover its obligations under this
				    Agreement with reputable carriers authorized in the applicable regions.
				  </p>

				  <h2>12. Force Majeure</h2>

				  <p>
				    Provider shall not be liable for any failure or delay in performance caused
				    by events beyond its reasonable control, including natural disasters, acts
				    of war or terrorism, pandemics, governmental actions, denial-of-service
				    attacks, or utility or internet service failures.
				  </p>

				  <h2>13. Miscellaneous</h2>

				  <p>
				    <strong>13.1. Independent Contractors.</strong> The parties are independent
				    contractors and not partners, employees, joint venturers, or agents.
				  </p>

				  <p>
				    <strong>13.2. Waiver.</strong> Failure to enforce any provision does not
				    constitute a waiver of future enforcement.
				  </p>

				  <p>
				    <strong>13.3. Notices.</strong> Notices to Provider must be sent to
				    FiscalNote, Inc., 1201 Pennsylvania Ave NW, Sixth Floor, Washington, DC
				    20004, USA, Attn: Legal Department, with a copy to legal@fiscalnote.com.
				  </p>

				  <p>
				    <strong>13.4. Severability.</strong> If any provision is held unenforceable,
				    the remaining provisions will remain in full force and effect.
				  </p>

				  <p>
				    <strong>13.5. Non-Parties.</strong>
				  </p>

				  <p>
				    <strong>13.5.1. Third-Party Beneficiaries.</strong> Except as provided in
				    Section 4.3, there are no third-party beneficiaries to this Agreement.
				  </p>

				  <p>
				    <strong>13.5.2. Assignability.</strong> Neither party may assign this
				    Agreement without prior written consent, except to Affiliates or in
				    connection with a merger or sale of substantially all assets. This
				    Agreement binds and benefits permitted successors and assigns.
				  </p>

				  <p>
				    <strong>13.6. Language.</strong> This Agreement is written in English.
				    Translations are provided for convenience only and are not legally binding.
				  </p>

				  <p>
				    <strong>13.7. Dispute Resolution.</strong>
				  </p>

				  <p>
				    <strong>13.7.1. Mandatory Arbitration.</strong> All disputes arising out of
				    or relating to these Terms or the Services shall be resolved by binding
				    arbitration. End Users may opt out within 30 days of first use by emailing
				    legal@fiscalnote.com.
				  </p>

				  <p>
				    <strong>13.7.2. Arbitration Forum.</strong> Arbitration shall be conducted
				    by National Arbitration and Mediation (“NAM”) under its applicable rules.
				    The Federal Arbitration Act governs these provisions.
				  </p>

				  <p>
				    <strong>13.7.3. Arbitration Procedures.</strong> Arbitration will be
				    conducted remotely where possible or in New York City, New York, before a
				    single arbitrator. The arbitrator may grant dispositive motions and issue
				    final awards.
				  </p>

				  <p>
				    <strong>13.7.4. Exceptions.</strong> Claims eligible for small claims court
				    or requests for injunctive relief related to misuse of Services or IP are
				    excluded from arbitration.
				  </p>

				  <p>
				    <strong>13.7.5. Class Action &amp; Jury Trial Waiver.</strong> Disputes must
				    be brought on an individual basis only. Class actions, class arbitrations,
				    and representative actions are waived.
				  </p>

				  <p>
				    <strong>13.7.6. Batch Arbitration.</strong> Substantially similar claims may
				    be administered in batches under NAM procedures, as specified in these
				    Terms.
				  </p>

				  <p>
				    <strong>13.7.7. Severability of Arbitration Provisions.</strong> If any part
				    of this section is unenforceable, the remainder remains effective unless it
				    would permit class proceedings.
				  </p>

				  <p>
				    <strong>13.7.8. Governing Law &amp; Venue.</strong> New York law governs these
				    Terms. Except as otherwise provided, venue lies exclusively in New York
				    City, New York.
				  </p>

				  <p>
				    <strong>13.8. Anti-Corruption.</strong> Each party represents that it has not
				    offered or received any improper payments or benefits in connection with
				    this Agreement.
				  </p>

				  <p>
				    <strong>13.9. Amendment / Changes.</strong> Provider may update these Terms
				    from time to time. Continued use of the Services constitutes acceptance of
				    the updated Terms.
				  </p>

				  <p>
				    <strong>Entire Agreement.</strong> This Agreement constitutes the entire
				    agreement between the parties and supersedes all prior agreements or
				    understandings relating to the subject matter hereof.
				  </p>

				  <h2>14. Definitions</h2>

				  <p>
				    <strong>“Affiliate”</strong> means any entity which directly or indirectly
				    controls, is controlled by, or is under common control with an entity.
				  </p>

				  <p>
				    <strong>“Control”</strong> means direct or indirect ownership or control of
				    more than 50% of the voting interests of the subject entity.
				  </p>

				  <p>
				    <strong>“Agreement”</strong> means the agreement for Services between End User
				    and Provider consisting of these Terms, any DPA, Privacy Policy, and/or Cookie
				    Policy.
				  </p>

				  <p>
				    <strong>“AI”</strong> means artificial intelligence.
				  </p>

				  <p>
				    <strong>“Applicable Law”</strong> means all legislation, statutes,
				    regulations, ordinances, rules, judgments, orders, decrees, rulings, and
				    other requirements enacted or imposed by any governmental or regulatory
				    authority applicable to a party under this Agreement.
				  </p>

				  <p>
				    <strong>“Content”</strong> means any data, media, information, or other
				    content made available through or in connection with the Services, including
				    Input, Output, and Provider Content.
				  </p>

				  <p>
				    <strong>“DPA”</strong> means the applicable Data Protection Agreement as set
				    forth in Section 8.
				  </p>

				  <p>
				    <strong>“End User”</strong> means any person or, in the case of an
				    organization, its employees, agents, contractors, or other individuals who
				    access or use the Services.
				  </p>

				  <p>
				    <strong>“End User Data”</strong> means (i) all data provided to Provider
				    through End User’s use of the Services, including Personal Data, and (ii)
				    Inputs.
				  </p>

				  <p>
				    <strong>“Intellectual Property Rights”</strong> means all rights associated
				    with copyrights, patents, trademarks, and trade secrets, whether registered
				    or unregistered, including rights to create derivative works, exclude others
				    from use, display marks, and apply for such rights.
				  </p>

				  <p>
				    <strong>“Person”</strong> means an individual, corporation, partnership,
				    trust, estate, association, or other legal entity.
				  </p>

				  <p>
				    <strong>“Personal Data”</strong> has the meaning given in Section 8.
				  </p>

				  <p>
				    <strong>“Provider”</strong> means FiscalNote, Inc., a Delaware corporation,
				    with offices at 1201 Pennsylvania Ave NW, 6th Floor, Washington, DC 20004.
				  </p>

				  <p>
				    <strong>“Provider Content”</strong> means Content owned or controlled by
				    Provider and made available through the Services.
				  </p>

				  <p>
				    <strong>“Terms of Use”</strong> or <strong>“Terms”</strong> means these terms
				    and conditions.
				  </p>

				  <h3>Digital Millennium Copyright Act</h3>

				  <p>
				    Provider does not tolerate inappropriate content or misconduct. Provider has
				    adopted the following copyright infringement policy in accordance with the
				    Digital Millennium Copyright Act (the “DMCA”).
				  </p>

				  <h4>DMCA Takedown Notice Procedures</h4>

				  <p>
				    If an End User believes Content infringes Intellectual Property Rights, a
				    notification (“DMCA Takedown Notice”) must be submitted including:
				  </p>

				  <ul>
				    <li>A physical or electronic signature of an authorized person;</li>
				    <li>
				      Identification of the copyrighted work(s) claimed to have been infringed;
				    </li>
				    <li>
				      Identification of the infringing material and information sufficient to
				      locate it;
				    </li>
				    <li>
				      Contact information for the submitting party, including address,
				      telephone number, and email if available;
				    </li>
				    <li>
				      A statement of good faith belief that the use is not authorized; and
				    </li>
				    <li>
				      A statement under penalty of perjury that the information is accurate and
				      authorized.
				    </li>
				  </ul>

				  <p>
				    DMCA notices should be sent to{' '}
				    <a href="mailto:legal@fiscalnote.com">legal@fiscalnote.com</a> or by mail to:
				    1201 Pennsylvania Ave NW, 6th Floor, Washington, DC 20004.
				  </p>

				  <p>
				    Failure to comply with Section 512(c)(3) of the DMCA may result in an invalid
				    notice. Knowingly submitting false claims may result in liability under
				    Section 512(f) of the DMCA.
				  </p>

				  <h4>Counter Notification Procedures</h4>

				  <p>
				    If an End User believes content was removed by mistake, a counter
				    notification may be submitted including:
				  </p>

				  <ul>
				    <li>The submitter’s signature;</li>
				    <li>
				      Identification of the removed material and its prior location;
				    </li>
				    <li>
				      Adequate contact information;
				    </li>
				    <li>
				      A statement under penalty of perjury of good faith belief of mistake; and
				    </li>
				    <li>
				      Consent to jurisdiction of the appropriate Federal District Court.
				    </li>
				  </ul>

				  <p>
				    Provider may restore content if no legal action is filed within ten (10)
				    business days. Provider will disable or terminate accounts of repeat
				    infringers.
				  </p>
				</div>
			</div>
		</MainLayout>
	)
}

export default Terms